module.exports = __webpack_public_path__ + "static/media/CL125_SE.4257a3b2.jpg";